const isPlainObject = (value) => (
  value !== null &&
  value instanceof Object &&
  !(value instanceof Array)
);

// ESLint is complaining about not needed escaped character,
// but they need to be escaped
/* eslint-disable-next-line */
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

exports.emailRegex = emailRegex;

exports.createTranslations = (keys) => (value) => {
  const isObject = isPlainObject(value);
  const hasAllKeys = keys.every((key) => !!value[key]);
  return isObject && hasAllKeys;
};

exports.isPlainObject = isPlainObject;

exports.isNaturalNumber = (value) => value >= 0;
exports.isPositiveNumber = (value) => value > 0;

exports.isEmailAddress = (email) => emailRegex.test(String(email).toLowerCase());

exports.isArrayOfStrings = (value) => Array.isArray(value) && value.every((item) => typeof item === 'string');

const hexChars = '[0-9ABCDEF]';
const hexSizes = [8, 6, 3];
const hexColorRegExp = hexSizes.map((size) => `^${hexChars}{${size}}$`).join('|');

exports.isHexColor = (string) => {
  if (!hexSizes.includes(string.length)) {
    return false;
  }
  const regExp = new RegExp(hexColorRegExp, 'ig');
  return regExp.test(string);
};

exports.isUrl = (url, base) => {
  try {
    new URL(url, base);
  } catch (err) {
    return false;
  }
  return true;
};

exports.isUnitSystem = (value) => ['metric', 'imperial'].includes(value);
exports.isValidDate = (value) => !isNaN(new Date(value));

exports.isPhoneNumber = (value) => /^[\d+\-#\s*()]+$/g.test(value);
